/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerNotificationResponse as ModelsCustomerCustomerNotificationResponse } from '../../models/Models/Customer/customer-notification-response';

export interface V3CustomersMeNotificationsNotificationIdGet$Plain$Params {
  notificationId: string;
}

export function v3CustomersMeNotificationsNotificationIdGet$Plain(http: HttpClient, rootUrl: string, params: V3CustomersMeNotificationsNotificationIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeNotificationsNotificationIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>;
    })
  );
}

v3CustomersMeNotificationsNotificationIdGet$Plain.PATH = '/v3/customers/me/notifications/{notificationId}';
